var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrijinKeywords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 0.499512,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#10DDED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12.4995,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#0F2C54"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 12.4995,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#0096CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrijinKeywords);
export default __webpack_public_path__ + "static/media/orijin-keywords.ca292deb30e76750f2d7c80fee47fdfe.svg";
export { ForwardRef as ReactComponent };